// extracted by mini-css-extract-plugin
export default {"container":"DeviceTests_container__DRQ1W","formSheet":"DeviceTests_formSheet__CB7x7","testInput":"DeviceTests_testInput__aEVHG","formFooter":"DeviceTests_formFooter__8O0qB"};